import { TYPE } from '@/constants';

import { Shape } from './shape';

export default class Line extends Shape {
  constructor(params) {
    super(params);
    this.initView();
  }

  initView() {
    const { shape, transform } = this.attributes;
    const [x1, y1, x2, y2] = shape;
    this.shape = this.canvas.line(x1, y1, x2, y2);
    this.view.add(this.shape);
    this.view.addClass(`shape-${this.subtype}`);
    const strokeWidth = this.attributes.styles['stroke-width'];
    if (strokeWidth !== undefined) this.setStyle('stroke-width', strokeWidth);
    this.view.transform(transform);
  }

  get subtype() {
    return TYPE.LINE;
  }

  toJSON() {
    const { uuid, type, subtype, sid } = this;
    const transform = this.view.transform('matrix');
    const attributes = Object.assign({}, this.attributes, {
      transform,
    });
    return Line.filteredJSON({
      uuid,
      sid,
      type,
      subtype,
      attributes,
    });
  }

  static fromJSON(params) {
    return Line.create(params);
  }

  static create(params) {
    const attributes = {
      transform: '',
      shape: [0, 0, 0, 0],
      styles: {},
    };
    params.attributes = Object.assign({}, attributes, params.attributes);
    return new Line(params);
  }
}
